var _style, _ellipse, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgValidatingOrchestration(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "eSRfZurIQkE1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 24",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "#eSRfZurIQkE2 {animation: eSRfZurIQkE2_s_do 1000ms linear 1 normal\r\n        forwards}@keyframes\r\n        eSRfZurIQkE2_s_do { 0% {stroke-dashoffset: 56.55} 100% {stroke-dashoffset: 0}}\r\n    ")), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "eSRfZurIQkE2",
    rx: 9,
    ry: 9,
    transform: "matrix(0-1 1 0 12 12)",
    fill: "none",
    stroke: "#366FE5",
    strokeDashoffset: 56.55,
    strokeDasharray: 56.55
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3461,14.961l5.0074-5.00745-.7071-.70711-4.3003,4.30026-1.99254-1.9926-.70711.7071L11.3461,14.961Z",
    clipRule: "evenodd",
    fill: "#366FE5",
    fillRule: "evenodd"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgValidatingOrchestration);
export default __webpack_public_path__ + "static/media/validating-orchestration.ce906936bfaa7dbd3840635b7b114cd9.svg";
export { ForwardRef as ReactComponent };